/* Consent is read and written only through Shopify's supported Customer Privacy API. */
if (!customElements.get('mg-cookie-preferences')) {
  customElements.define('mg-cookie-preferences', class extends HTMLElement {
    connectedCallback() {
      this.operation = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('[data-status]');
      this.fields = this.querySelector('fieldset');
      this.retryButton = this.querySelector('[data-retry]');
      this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.retryButton.addEventListener('click', () => this.open(), options);
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        this.save(false);
      }, options);
      this.querySelector('[data-decline]').addEventListener('click', () => this.save(true), options);
      this.dialog.addEventListener('close', () => {
        this.cancel();
        this.querySelector('[data-open]').focus();
      }, options);
    }

    disconnectedCallback() {
      this.controller.abort();
      this.cancel();
    }

    cancel() {
      this.operation++;
      clearTimeout(this.timeout);
      clearTimeout(this.retry);
    }

    open() {
      this.cancel();
      const operation = this.operation;
      if (!this.dialog.open) this.dialog.showModal();
      this.fields.disabled = true;
      this.retryButton.hidden = true;
      this.status.textContent = this.dialog.dataset.loading;
      const started = Date.now();
      let requested = false;
      let fallbackRequested = false;
      this.timeout = setTimeout(() => this.fail(operation, 'privacy-api-timeout'), 10000);
      const ready = () => {
        if (operation !== this.operation) return;
        const api = window.Shopify?.customerPrivacy;
        if (typeof api?.currentVisitorConsent === 'function' && typeof api.setTrackingConsent === 'function') {
          this.api = api;
          try {
            this.refresh();
            clearTimeout(this.timeout);
            clearTimeout(this.retry);
            this.fields.disabled = false;
            this.status.textContent = '';
          } catch {
            this.fail(operation, 'privacy-read-failed');
          }
          return;
        }
        if (!requested && typeof window.Shopify?.loadFeatures === 'function') {
          requested = true;
          // Poll independently: some loader failures never invoke their callback.
          try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}); } catch {}
        }
        if (Date.now() - started >= 1500 && !fallbackRequested) {
          fallbackRequested = true;
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js';
          script.async = true;
          script.onerror = () => { script.remove(); this.fail(operation, 'privacy-script-failed'); };
          script.onload = () => script.remove();
          document.head.appendChild(script);
        }
        this.retry = setTimeout(ready, 100);
      };
      ready();
    }

    refresh() {
      const consent = this.api.currentVisitorConsent();
      for (const name of ['preferences', 'analytics', 'marketing']) {
        this.querySelector(`[name="${name}"]`).checked = consent[name] === 'yes';
      }
      return consent;
    }

    save(decline) {
      if (!this.api || this.fields.disabled) return;
      this.cancel();
      const operation = this.operation;
      const consent = {};
      for (const name of ['preferences', 'analytics', 'marketing']) {
        consent[name] = decline ? false : this.querySelector(`[name="${name}"]`).checked;
      }
      this.fields.disabled = true;
      this.retryButton.hidden = true;
      this.status.textContent = this.dialog.dataset.saving;
      this.timeout = setTimeout(() => this.fail(operation), 10000);
      try {
        // Data-sale choices are separate; this action does not alter them.
        const pending = this.api.setTrackingConsent(consent, error => {
          if (operation !== this.operation) return;
          clearTimeout(this.timeout);
          if (error) return this.fail(operation);
          try {
            const saved = this.refresh();
            if (Object.keys(consent).some(name => saved[name] !== (consent[name] ? 'yes' : 'no'))) {
              return this.fail(operation);
            }
            this.fields.disabled = false;
            this.status.textContent = this.dialog.dataset.saved;
          } catch {
            this.fail(operation);
          }
        });
        pending?.catch(() => this.fail(operation));
      } catch {
        this.fail(operation);
      }
    }

    fail(operation, reason = 'privacy-save-failed') {
      if (operation !== this.operation) return;
      console.warn(`[MilGadget privacy] ${reason}`);
      this.cancel();
      this.fields.disabled = true;
      this.retryButton.hidden = false;
      this.status.textContent = this.dialog.dataset.error;
    }
  });
}
